import APP_CONFIG from "../configs/environment";
export const autoRefreshFrequency = APP_CONFIG.appSettingsData.autoRefreshFrequency;
export const validationLimitValues = {
  brandNameMaxLength: 64,
};
